import React, { useEffect } from 'react'
import { StyledInformationList } from 'spa/member/components/InformationList/styled'
import { Information } from 'spa/member/components/InformationList/types'
import { API } from 'javascripts/api'
import { TopInformationListProps } from './types'

export const InformationList: React.FC<TopInformationListProps> = props => {
  const [informationList, setInformationList] = React.useState<Information[]>([])

  useEffect(() => {
    const fetchInformationList = async () => {
      try {
        const response = await API.apiV1UsersTopInformationGet()
        setInformationList(response.data as Information[])
      } catch (error) {
        setInformationList([])
      }
    }

    fetchInformationList()
  }, [])

  return <StyledInformationList informationList={informationList} className={props.className} />
}
